import { lightThemeObject } from "./LightTheme"; // eslint-disable-next-line import/prefer-default-export

export var colorVar = function colorVar(color) {
  return "var(".concat(color, ", ").concat(lightThemeObject[color], ")");
};
//# sourceMappingURL=colorVar.js.map